<template>
</template>

<script>

/**
 * Vue: collection-blocks (collection-blocks)
 * -----------------------------------------------------------------------------
 * New collection blocks.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'CollectionBlocks',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './collection-blocks';
</style>
